import React, { Component } from 'react'
import { connect } from 'react-redux'
import PublicComponent from '../components/Public'
import PublicHome from './PublicHome'
import PublicLogin from './PublicLogin'
import PublicRecoverStart from './PublicRecoverStart'
import PublicRecover from './PublicRecover'
import PublicPreForm from './PublicPreForm'
import PublicForm from './PublicForm'
import PublicSimpleForm from './PublicSimpleForm'
import PublicIssue from './PublicIssue'
import PublicSearch from './PublicSearch'
import SimplePublicIssue from './SimplePublicIssue'
import AdminDocs from './AdminDocs'
import AdminDocsForm from './AdminDocsForm'
import AdminDocsView from './AdminDocsView'
import ProfileSettings from './ProfileSettings'
import { withRouter, Route, Switch } from 'react-router-dom'

class App extends Component {

    render() {
        return (
            <PublicComponent {...this.props} >
                <Switch>
                    <Route exact={true} path="/" component={PublicHome} />
                    <Route exact={true} path="/inicio" component={PublicHome} />
                    <Route path="/preform" component={PublicPreForm} />
                    <Route path="/login" component={PublicLogin} />
                    <Route path="/issue/:id?" component={PublicForm} />
                    <Route path="/issue" component={PublicForm} />
                    <Route path="/publico" component={PublicSimpleForm} />
                    <Route path="/details/:id" component={PublicIssue} />
                    <Route path="/detailssimple/:id/:code" component={SimplePublicIssue} />
                    <Route path="/search" component={PublicSearch} />
                    <Route path="/docs/form/:id?" component={AdminDocsForm} />
                    <Route path="/docs/:id" component={AdminDocsView} />
                    <Route path="/docs" component={AdminDocs} />
                    <Route path="/settings" component={ProfileSettings} />
                    <Route path="/recover/:token" component={PublicRecover} />
                    <Route path="/recover" component={PublicRecoverStart} />
                </Switch>
            </PublicComponent>
        )
    }
}

const mapStateToProps = (state) => {
    const nextProps = Object.assign({}, state.auth)
    return nextProps
}

const mapDispatchToProps = (dispatch, props) => {
    return {}
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(App))



// WEBPACK FOOTER //
// ./src/containers/Public.js